module.exports = __webpack_public_path__ + "static/img/nanxinghaibao.03d09b5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/qqly/nanxinghaibao.gif
// module id = sl+L
// module chunks = 0